import '@/plugins/vue-composition-api'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import { CompanyAPI, UserAPI } from '@/api/backend-client'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'

import '@/plugins/components'
import '@/plugins/filters-date'
import '@/plugins/filters-i18n'
import '@/plugins/filters-string'
import '@/plugins/sentry'
import '@/plugins/v-money'
import '@/plugins/vee-validate'
import '@/plugins/vue-datetime'
import '@/plugins/vue-debounce'
import '@/plugins/vue-flatpickr-component'
import '@/plugins/vue-google-maps'
import '@/plugins/vue-mention'
import '@/plugins/vue-notification'
import '@/plugins/vue-upload-component'
import '@/plugins/tracking/hotjar'
import '@/plugins/portal-vue'

const startApp = async () => {
    Vue.config.productionTip = false
    window.keyvue = window.keyvue || {}

    const [ currentUser, currentCompany ] = await Promise.all([
        UserAPI.getCurrentUser(),
        CompanyAPI.getCurrentCompany(),
    ])

    const state = new Vue({
        data: {
            $currentUser: currentUser,
            $currentCompany: currentCompany,
            $dragItem: null,
        },
    })

    await store.dispatch('referrals/applyDateRangeFilter', {
        range: state.$data.$currentCompany?.defaultDateRange || 'all',
        update: false,
    })

    await store.dispatch('orders/applyDateRangeFilter', {
        range: state.$data.$currentCompany?.defaultDateRange || 'all',
        update: false,
    })

    Vue.mixin({
        computed: {
            $currentUser: {
                get: () => state.$data.$currentUser,
                set: (value: User) => state.$data.$currentUser = value,
            },
            $currentCompany: {
                get: () => state.$data.$currentCompany,
                set: (value: Company) => {
                    state.$data.$currentCompany = value

                    store.dispatch('referrals/applyDateRangeFilter', {
                        range: state.$data.$currentCompany?.defaultDateRange || 'all',
                        update: false,
                    })

                    store.dispatch('orders/applyDateRangeFilter', {
                        range: state.$data.$currentCompany?.defaultDateRange || 'all',
                        update: false,
                    })
                },
            },
            $dragItem: {
                get: () => state.$data.$dragItem,
                set: (value: HTMLElement) => state.$data.$dragItem = value,
            },
            $version: {
                get: () => process.env.VUE_APP_VERSION,
            },
        },
    })

    new Vue({
        router,
        i18n,
        store,

        render: h => h(App),
    }).$mount('#app')
}

startApp().then()
